import { useRef, useEffect, useMemo } from 'react';
import giraClient from '@atlassian/jira-apollo-gira/src/index.tsx';
import { transformOriginUrl } from '@atlassian/jira-issue-create-commons/src/common/utils/transform-stargate-url/index.tsx';
import { useSitePickerContext } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/controllers/use-site-picker-context/index.tsx';

export const getGiraClient = () => giraClient;

export const useIssueCreateFromAnywhereContext = () => {
	const cloudIdRef = useRef('');

	const [{ selectedCloudId }] = useSitePickerContext();

	useEffect(() => {
		if (selectedCloudId && cloudIdRef.current !== selectedCloudId) {
			cloudIdRef.current = selectedCloudId;
		}
	}, [selectedCloudId]);

	const originUrl = useMemo(() => transformOriginUrl(selectedCloudId), [selectedCloudId]);
	return {
		giraClient: {
			...getGiraClient(),
			...(originUrl && { clientCreator: () => getGiraClient()?.clientCreator(originUrl) }),
		},
		resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId,
	};
};
